const storages = {
    Swarm: {
      Symbol: "Swarm",
      icon: require(`@/assets/images/swarm.png`),
      desc: "Swarm - Decentralized Storage",
    },
    Sia: {
      Symbol: "Sia",
      icon: require(`@/assets/images/sia.png`),
      desc: "Sia - Decentralized Storage",
    },
    // Decast: {
    //   Symbol: "Decast",
    //   icon: "decast.png",
    //   desc: "Decast - Local Storage"
    // }
  };
  
  export default storages;
  